module.exports = __webpack_public_path__ + "a8b5350a0f694526d8c6d1e39675c261.svg";